import { createRoot } from 'react-dom/client'
import React from 'react'
import './components/table/react-table-config.d'
import App from './app'
import reportWebVitals from './reportWebVitals'

import { DndProvider } from 'react-dnd'
import { isBrowser } from 'react-device-detect'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

import './index.css'

const container = document.getElementById('root')
const root = createRoot(container)

const dndBackend = isBrowser ? HTML5Backend : TouchBackend

const app =
  process.env.NODE_ENV === 'development' ? (
    <DndProvider backend={dndBackend}>
      <App />
    </DndProvider>
  ) : (
    <React.StrictMode>
      <DndProvider backend={dndBackend}>
        <App />
      </DndProvider>
    </React.StrictMode>
  )
root.render(app)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
